import React, { PureComponent, Component } from 'react';
import ProcesamientoParcial from './ProcesamientoParcial'
import ArchivoValido from './ArchivoValido';
import Periodicidad from './Periodicidad';
import PlazoMaximo from './PlazoMaximo';


class Ejecucion extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {data, selectRadio, changeInput, setCheck, seleccionarCombo} = this.props;

        return (
            <div>
                <div className="row top-separator-xs">
                    <div className="col-xs-12">
                        <div className="row bottom-separator">
                            <div className="col-xs-12">
                                <h2>
                                    Ejecución
                            </h2>
                            </div>
                        </div>
                    </div>
                </div>

                <ProcesamientoParcial data={data} selectRadio={selectRadio} changeInput={changeInput}/>
                <ArchivoValido proceso={data.proceso} selectRadio={selectRadio} />
                <PlazoMaximo data={data}  changeInput={changeInput} />
                <Periodicidad data={data} selectRadio={selectRadio} changeInput={changeInput} setCheck={setCheck} seleccionarCombo={seleccionarCombo} />
            </div>
        )
    };
}

export default Ejecucion;